/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileCode32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <path
                fill="#E33D55"
                d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill={vars.white}
                d="M17.553 13.776a.5.5 0 01.894.448l-4 8a.5.5 0 01-.894-.448zm-4.83 1.808a.5.5 0 11.554.832L10.901 18l2.376 1.584a.5.5 0 11-.554.832l-3-2a.5.5 0 010-.832zm6.554 0l3 2a.5.5 0 010 .832l-3 2a.5.5 0 11-.554-.832L21.099 18l-2.376-1.584a.5.5 0 01.554-.832z"
            />
        </g>
    </AccessibleSVG>
);

export default FileCode32;
